import React, { useState } from 'react';
import { useCSS } from '../../lib/hooks.js';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, scoresToBracket, getRoundLabel, isNotEmpty, getLayout, isColorBright, RGB_2_HEX } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';

import BracketCandidates from '../front/layers/BracketCandidates';
import RoundVotesLayer from '../front/layers/RoundVotesLayer';

import BracketsNotCanvas from '../games/BracketsNotCanvas';

const FormattedMessageWithClass = (props) => {
	return (
		<FormattedMessage {...props}>
			{(txt) => (
				<span className={props.className}>{txt}</span>
			)}
		</FormattedMessage>
	)
};

const sortCandidates = (candidates) => {
	//return candidates;

	return candidates.sort((x, y) => {
		if(x.round > y.round) return -1;
		if(x.round < y.round) return 1;
		return 0;
	});
};

function ViewMosaic({candidates, matches, is_builder, main_font, main_color, display_view, promotion, ...props}) {
	const is_single = (props.is_single != undefined) ? props.is_single : false;
	const bracket = (props.bracket != undefined) ? props.bracket : false;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	if(!bracket && is_builder) {
		return (
			<div class="gui_main_text_color_on_bg">{i18n("There isn't any bracket competition to display.")}</div>
		)
	}

	const bracket_id = (bracket.id != undefined) ? bracket.id : false;

	const [display_candidates, setDisplayCandidates] = useState(false);

	const gotoParticipate = (link) => {
		window.location.href = link;
	};

	let teams = [];
	let candidates_alive = 0;
	let winner = false;
	candidates.map((c) => {
		if(c.BracketCandidate.bracket_id == bracket_id) {
			teams.push(c.BracketCandidate);
			if(parseInt(bracket.current_round) <= parseInt(c.BracketCandidate.round)) candidates_alive++;
			if(parseInt(bracket.num_rounds) < parseInt(c.BracketCandidate.round)) winner = c.BracketCandidate;
		}
	});

	let _matches = [];
	matches.map((m) => {
		if(m.BracketMatch.bracket_id == bracket_id) _matches.push(m);
	});
	let matches_results = scoresToBracket(_matches, parseInt(bracket.num_rounds), parseInt(bracket.current_round));

	let link_to_single = (window.in_widget && window.widget_redirect_url != undefined) ? window.widget_redirect_url : ((!is_single && !is_builder) ? `/single_brackets/${promotion.id}/${bracket.id}` : null);
	const bracket_props = {
		bracket:bracket,
		current_round:parseInt(bracket.current_round),
		is_builder:is_builder,
		in_mosaic:true,
		is_single:is_single,
		link_to_single:link_to_single,
		main_color:main_color,
		main_font:main_font,
		matches_results:matches_results,
		promotion:promotion,
		teams:teams,
	};

	let rounds_in_bracket = [];
	for(var i = 1; i < parseInt(bracket.num_rounds) + 1; i++) {
		rounds_in_bracket.push({
			label:getRoundLabel(bracket, i, false, props.intl),
			start_date:bracket['start_round_' + i],
			end_date:bracket['end_round_' + i],

		});
	}

	const total_brackets = (props.total_brackets != undefined) ? props.total_brackets : 1;

	if(is_single) {
		let back_link = (promotion.brackets_enabled != undefined && promotion.brackets_enabled) ? `/brackets/${promotion.id}` : `/p/${promotion.id}`;

		return (
			<div class={'single_bracket_page' + ((window.in_widget) ? ' in_widget' : '')}>
				{(!is_builder && !window.in_widget) && (
					<div id="floating_back" class="floating_back">
						<ActionLink
							_href={back_link}
							icon='knk-arrow-l-big'
							_class={{other:'original_color_item whiteColor whiteIcon'}}
						>Go back</ActionLink>
					</div>
				)}

				<div id="bracket_dom" class="brackets_display bracket_dom">
					<BracketsNotCanvas
						key={`bracket_${bracket_id}`}
						{...bracket_props}
					/>
				</div>
			</div>
		)
	}

	const tz = promotion.timezone;
	const bracket_start_date = bracket['start_round_1'];
	const bracket_end_date = bracket['end_round_' + parseInt(bracket.num_rounds)];
	const open = ((moment.tz(bracket_start_date, tz).isBefore() && moment.tz(bracket_end_date, tz).isAfter()) || (moment.tz(bracket_start_date, tz).isBefore() && bracket_end_date == null)) ? true : false;
	const closed = (moment.tz(bracket_end_date, tz).isBefore()) ? true : false;
	const pending = (!open && !closed) ? true : false;

	let bracket_state;
	if(open) {
		bracket_state = 'open';
	} else if(closed) {
		bracket_state = 'closed'
	} else {
		bracket_state = 'pending';
	}

	let display_votes = (true || (bracket.display_votes != undefined && bracket.display_votes == '1')) ? true : false;

	let link_to_participate = '/promotions/participate/' + promotion.id;

	let sorted_teams = sortCandidates(teams);

	const [ display_round_votes, setDisplayRoundVotes ] = useState(false);

	const custom_labels = promotion?.custom_labels ?? {};
	const enter_button_label = (isNotEmpty(custom_labels, 'enter_button')) ? custom_labels.enter_button : i18n("Enter");
	const layout_props = getLayout(promotion);
	const is_main_color_bright = isColorBright(RGB_2_HEX(layout_props.color.text_color));

	return (
		<div class={'is_' + bracket_state + ((window.in_widget) ? ' in_widget' : '')}>
			<div class="bracket_info">
				<div class="textual_info gui_main_text_color_on_bg">
					<div class="stage_info">
						<h2 class="stage_title">{bracket.title}</h2>

						<p class="stage_description">
							<strong>
								{(!winner && candidates_alive > 1) ? (
									<FormattedMessage id="{num} candidates ({alive} left)" values={{num:Math.pow(2, parseInt(bracket.num_rounds)), alive:candidates_alive}} />
								) : (
									<FormattedMessage id="{num} candidates" values={{num:Math.pow(2, parseInt(bracket.num_rounds))}} />
								)}
							</strong>

							<ActionLink _class={{other:'gui_not_in_start_small'}} onClick={() => setDisplayCandidates(true)}>View candidates</ActionLink>
						</p>

						{(winner !== false) && (
							<h2 class="winner knk-winners gui_small_icon">{i18n("Winner")}: <strong>{winner.name}</strong></h2>
						)}
					</div>

					<div class="state_info gui_not_in_top_tiny">
						<ul class="rounds_in_bracket">
							{rounds_in_bracket.map((round, r) => {
								const round_open = (moment.tz(round.start_date, tz).isBefore() && moment.tz(round.end_date, tz).isAfter()) ? true : false;
								const round_closed = (moment.tz(round.end_date, tz).isBefore()) ? true : false;
								const round_pending = (!round_open && !round_closed) ? true : false;

								if(round_open && bracket['stage_id_round_' + (r + 1)] != undefined) {
									link_to_participate += '/' + bracket['stage_id_round_' + (r + 1)];
								}

								let li_class = null;
								if(open) {
									li_class = ((round_open) ? 'ep-circle' : ((round_closed) ? 'knk-off' : 'knk-white-space')) + ' gui_small_icon gui_pos_rel';
									if(round_open) li_class += ' with_link';
								}

								return (
									<li key={`bracket_${bracket.id}_round_${r}`} class={li_class} onClick={(round_open) ? () => gotoParticipate(link_to_participate) : null}>
										{(round_open) && (
											<span class={'ep-play gui_small_icon ' + ((is_main_color_bright) ? 'blackIcon' : 'whiteIcon')} />
										)}

										<span><strong>{getRoundLabel(bracket, (r + 1), false, props.intl)}</strong>: </span>

										{(round_open) && (
											<span>
												<strong>{i18n("open", 'ucfirst')}</strong> (<FormattedMessage id="{time} left" values={{time:moment.tz(round.end_date, tz).fromNow(true)}} />)
											</span>
										)}

										{(round_pending) && (
											<span>
												<span>{i18n("coming soon", 'ucfirst')}</span>
												{(round.start_date != null) && (
													<span> ({moment.tz(round.start_date, tz).fromNow()})</span>
												)}
											</span>
										)}

										{(round_closed) && (
											<span>
												<span>{i18n("closed", 'ucfirst')}</span>

												{(display_votes) && (
													<ActionLink _class={{other:'gui_not_in_start_small'}} onClick={() => setDisplayRoundVotes(r + 1)}>View votes</ActionLink>
												)}
											</span>
										)}
									</li>
								)
							})}
						</ul>
					</div>
				</div>

				<div class="participate_button">
					<ActionLink _class={{icon:'knk-brackets'}} _href={link_to_single}>View bracket</ActionLink>

					{(open) && (
						<ActionLink _class={{icon:'knk-play'}} _href={link_to_participate} autotranslate={false}>{enter_button_label}</ActionLink>
					)}
				</div>
			</div>

			{(display_votes && display_round_votes !== false) && (
				<RoundVotesLayer
					backButton={() => setDisplayRoundVotes(false)}
					bracket={bracket}
					is_builder={is_builder}
					main_color={main_color}
					matches_results={matches_results}
					promotion={promotion}
					round={display_round_votes}
					teams={sorted_teams}
				/>
			)}

			{(display_candidates) && (
				<BracketCandidates
					backButton={() => setDisplayCandidates(false)}
					bracket={bracket}
					link_to_single_bracket={link_to_single}
					is_builder={is_builder}
					promotion={promotion}
					teams={sorted_teams}
				/>
			)}
		</div>
	)
}

function BracketMosaic(props) {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	useCSS('comp/brackets.css');

	const promotion = props.promo;
	if(props.promo == undefined || props.brackets == undefined) return null;
	
	const brackets = props.brackets;
	if(brackets.length == 0) return null;
	
	const is_builder = props?.is_builder ?? false;
	const is_single = props?.is_single ?? false;
	const candidates = props.candidates;
	const matches = props.matches;
	const layout_props = getLayout(promotion);
	const main_color = layout_props.color.main_color;
	const main_font = layout_props.text.main_font;

	let brackets_in_mosaic = brackets.filter((obj) => {
		return (obj.Bracket.status != undefined && obj.Bracket.current_round > 0) ? ((obj.Bracket.status == '1') ? true : false) : false;
	});

	const container_class = ['gui_brackets_landing'];

	const mosaic_props = {
		candidates:candidates,
		display_view:'brackets',
		matches:matches,
		intl:props.intl,
		is_builder:is_builder,
		main_font:main_font,
		main_color:main_color,
		promotion:promotion,
		total_brackets:brackets_in_mosaic.length,
	};

	if(is_single) {
		let this_bracket = brackets_in_mosaic.find((obj) => {
			return obj.Bracket.id == props.bracket_id;
		});

		if(this_bracket == undefined) return null;

		return (
			<ViewMosaic
				bracket={this_bracket.Bracket}
				is_single={true}
				{...mosaic_props}
			/>
		)
	}

	if(brackets_in_mosaic.length == 0) {
		return (
			<div class={'gui_global_brackets' + ((is_builder) ? ' awesome' : '')}>
				<div class="empty_mosaic gui_main_text_color_on_bg">
					<p>{i18n("There is no participation stage/round open")}.</p>
				</div>
			</div>
		)
	}
	
	const custom_labels = promotion?.custom_labels ?? {};
	const enter_button_label = (isNotEmpty(custom_labels, 'enter_button')) ? custom_labels.enter_button : i18n("Enter");
	const entries_button_label = (isNotEmpty(custom_labels, 'view_entries_button')) ? custom_labels.view_entries_button : ((promotion.votable_entries == '1') ? i18n("View and vote for entries") : i18n("View entries"));

	const in_mosaic = (props.in_mosaic != undefined) ? props.in_mosaic : false;

	const enter_target = window?.enter_target ?? '_self';

	return (
		<div class={'gui_global_brackets' + ((is_builder) ? ' awesome' : '')}>
			<div class={container_class.join(" ")}>
				{(in_mosaic) && (
					<article class="promo_data template_module info_flexwrap gui_main_actions">
						{(!promotion.hide_enter_button || promotion.hide_enter_button == '0') && (
							<div class="template_submodule mod_align_center call_to_action_flex enter_flexwrap">
								<div class="enter flex_button gui_big_button register_flex">
									<ActionButton
										_fullclass=""
										_href={(!is_builder) ? `/promotions/participate/${promotion.id}` : null}
										_target={enter_target}
										autotranslate={false}
									>{enter_button_label}</ActionButton>
								</div>
							</div>
						)}

						{(promotion.public_entries != '0') && (
							<div class="template_submodule mod_align_center entries_button_flex">
								<span class="view_entries">
									<ActionLink
										_href={(!is_builder) ? `/entries/${promotion.id}` : null}
										autotranslate={false}
									>{entries_button_label}</ActionLink>
								</span>
							</div>
						)}
					</article>
				)}

				{(brackets_in_mosaic.length > 0) && (
					<div class="multibrackets_list gui_multiparticipation_landing without_context is_list in_bottom">
						{brackets_in_mosaic.map((bracket, b) => {
							return (
								<ViewMosaic
									key={`multi_bracket_${b}`}
									bracket={bracket.Bracket}
									{...mosaic_props}
								/>
							)
						})}
					</div>
				)}
			</div>
		</div>
	);
}

export default injectIntl(BracketMosaic);